import type { DriverPenaltySeverity, DriverPenaltyStatus } from '@/backend/market'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class DriverPenaltyFilterEntity {
  driver?: DriverEntity | null
  region?: RegionMiniEntity | null
  status?: DriverPenaltyStatus
  severity?: DriverPenaltySeverity
  page?: number
  limit?: number
}
